<template>
  <div class="hide-sm">
    <v-menu
      bottom
      rounded
      transition="slide-y-transition"
      nudge-bottom="4"
      max-width="206"
      offset-y
      :close-on-content-click="false"
    >
      <template #activator="{ on: onMenu }">
        <v-tooltip bottom :open-on-focus="false">
          <template #activator="{ on: onTooltip }">
            <v-btn icon v-on="{ ...onMenu, ...onTooltip }">
              <i class="pi pi-palette p-fs-xxxl text-p-dark"></i>
            </v-btn>
          </template>
          <span> {{ label.button.appearanceSetting }} </span>
        </v-tooltip>
      </template>
      <v-list class="pt-1">
        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.colorSelection }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28">
          <v-btn-toggle borderless class="d-flex flex-wrap bg-p-white">
            <v-btn
              v-for="(item, index) in colors"
              :key="index"
              class="theme-color-btn"
            >
              <v-icon :color="item.color" @click="setColor(item.colorName)">
                mdi-circle
              </v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-list-item>

        <v-divider class="mt-2 mb-1" />

        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.menuType }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28" @change="setMenuType">
          <v-radio-group
            v-model="menuType"
            hide-details
            class="my-0 py-0 appearance-label"
            row
            @change="setMenuType"
          >
            <v-radio
              class="ms-0"
              color="first"
              :label="label.form.vertical"
              :value="true"
            ></v-radio>
            <v-radio
              v-if="!isSmallScreen"
              color="first"
              :label="label.form.horizontal"
              :value="false"
            ></v-radio>
          </v-radio-group>
        </v-list-item>

        <v-divider class="my-1" />

        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.language }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28 pb-2">
          <v-radio-group
            v-model="language"
            hide-details
            class="my-0 py-0 appearance-label"
            row
            @change="setTemplate"
          >
            <v-radio
              class="ms-0"
              color="first"
              :label="label.form.fa"
              :value="1"
            ></v-radio>
            <v-radio color="first" :label="label.form.en" :value="2"></v-radio>
          </v-radio-group>
        </v-list-item>

        <v-divider class="my-1" />

        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.font }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28">
          <v-slider
            :value="currentIndex"
            readonly
            hide-details
            min="1"
            max="10"
            step="1"
            color="first"
            track-color="grey"
          >
            <template v-slot:prepend>
              <v-icon color="first" @click="decreaseFont">mdi-minus</v-icon>
            </template>
            <template v-slot:append>
              <v-icon color="first" @click="increaseFont">mdi-plus</v-icon>
            </template>
          </v-slider>
        </v-list-item>

        <v-divider class="my-1" />

        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.dateType }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28">
          <v-autocomplete
            v-model="dateType"
            :items="dateTypeOptions"
            outlined
            dense
            hide-details
            color="first"
            class="text-center mb-2"
            item-color="first"
            @input="setDateType"
          >
            <template v-slot:append>
              <v-icon class="chevron-icon" size="14pt">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-autocomplete>
        </v-list-item>

        <v-divider class="my-1" />

        <v-list-item class="px-2 p-fw-semibold min-h-28 text-p-dark p-fs-xs">
          {{ label.form.dateTimeFormat }}
        </v-list-item>
        <v-list-item class="px-1 min-h-28">
          <v-autocomplete
            v-model="dateTimeFormat"
            :items="dateTimeFormatOptions"
            outlined
            dense
            hide-details
            color="first"
            class="text-center pb-2"
            item-color="first"
            @input="setDateType"
          >
            <template v-slot:append>
              <v-icon class="chevron-icon" size="14pt">
                mdi-chevron-down
              </v-icon>
            </template>
          </v-autocomplete>
        </v-list-item>

        <!-- <v-list-item class="px-1 min-h-28">
          <v-radio-group
            v-model="fontFamily"
            hide-details
            class="my-0 py-0"
            row
            @change="setFontFamily"
          >
            <v-radio
              class="ms-0"
              color="first"
              :label="label.form.iranyekan"
              value="main"
            ></v-radio>
            <v-radio
              v-if="!isSmallScreen"
              color="first"
              :label="label.form.shabnam"
              value="second"
            ></v-radio>
          </v-radio-group>
        </v-list-item> -->
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import label from "@/lang/StaticLabels.js";
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "AppearanceConfigurator",
  data() {
    return {
      label,
      menuType: true,
      language: 1,
      dateType: null,
      dateTimeFormat: null,
      currentTheme: "default",
      currentIndex: 5,
      fontFamily: "main",
      fontFamilies: {
        main: "iranyekan",
        second: "Shabnam",
        // english: "Poppins, sans-serif",
      },
      fontSizes: {
        xxxxSmall: 5.5,
        xxxSmall: 6.5,
        xxSmall: 7.5,
        xSmall: 8,
        small: 9,
        normal: 9.5,
        medium: 10.5,
        large: 11,
        xLarge: 12,
        xxLarge: 13,
        xxxLarge: 13.5,
        xxxxLarge: 14,
        xxxxxLarge: 15,
        big: 16,
        xBig: 17,
        xxBig: 18,
        xxxBig: 19,
        huge: 20,
        xHuge: 21,
        xxHuge: 22,
        xxxHuge: 23,
      },
      colors: [
        {
          color: "#334155",
          colorName: "color1",
        },
        {
          color: "#009688",
          colorName: "color2",
        },
        {
          color: "#10b981",
          colorName: "color3",
        },
        {
          color: "#22c55e",
          colorName: "color4",
        },
        {
          color: "#84cc16",
          colorName: "color5",
        },
        {
          color: "#f97316",
          colorName: "color6",
        },
        {
          color: "#f59e0b",
          colorName: "color7",
        },
        {
          color: "#eab308",
          colorName: "color8",
        },
        {
          color: "#14b8a6",
          colorName: "color9",
        },
        {
          color: "#06b6d4",
          colorName: "color10",
        },
        {
          color: "#0ea5e9",
          colorName: "color11",
        },
        {
          color: "#3b82f6",
          colorName: "color12",
        },
        {
          color: "#6366f1",
          colorName: "color13",
        },
        {
          color: "#8b5cf6",
          colorName: "color14",
        },
        {
          color: "#a855f7",
          colorName: "color15",
        },
        {
          color: "#d946ef",
          colorName: "color16",
        },
        {
          color: "#ec4899",
          colorName: "color17",
        },
        {
          color: "#f43f5e",
          colorName: "color18",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      themeMode: "themeMode",
      profile: "userProfile",
      dateTypeOptions: "dropdownX/dateTypeOptions",
      dateTimeFormatOptions: "dropdownX/dateTimeFormatOptions",
      postCheckHeader: "postCheckHeader",
    }),
    isSmallScreen() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    // currentIndex() {
    //   return ((this.currentIndex + 1) / 10) * 100;
    // },
  },
  watch: {
    postCheckHeader() {
      if (this.postCheckHeader) {
        localStorage.setItem("DateType", JSON.stringify(this.dateType));
        localStorage.setItem(
          "DateTimeFormat",
          JSON.stringify(this.dateTimeFormat),
        );
        location.reload();
      }
    },
    isSmallScreen() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.menuType = true;
      }
    },
    profile() {
      if (this.profile) {
        this.dateType = this.profile.dateType;
        this.dateTimeFormat = this.profile.dateTimeFormat;
        localStorage.setItem("DateType", JSON.stringify(this.profile.dateType));
      }
    },
  },
  methods: {
    callMethod(methodName) {
      if (this[methodName]) {
        this[methodName]();
      } else {
        console.error(`Method ${methodName} not found`);
      }
    },
    clearThemeClasses() {
      document.body.classList.remove(
        "color1-theme",
        "color2-theme",
        "color3-theme",
        "color4-theme",
        "color5-theme",
        "color6-theme",
        "color7-theme",
        "color8-theme",
        "color9-theme",
        "color10-theme",
        "color11-theme",
        "color12-theme",
        "color13-theme",
        "color14-theme",
        "color15-theme",
        "color16-theme",
        "color17-theme",
        "color18-theme",
      );
    },
    setColor(theme) {
      this.clearThemeClasses();
      this.currentTheme = theme;
      localStorage.setItem("mitaThemeColor", JSON.stringify(theme));
      document.body.classList.add(theme + "-theme");
    },
    setTemplate() {
      localStorage.setItem("mitaLanguage", JSON.stringify(this.language));

      if (this.language === 1) {
        document.documentElement.style.setProperty("--direction", "rtl");
        axios.defaults.headers.common["Accept-language"] = "fa-IR";
      } else {
        document.documentElement.style.setProperty("--direction", "ltr");
        axios.defaults.headers.common["Accept-language"] = "en-US";
      }

      setTimeout(() => {
        window.location.reload();
      }, 50);
    },
    setMenuType() {
      localStorage.setItem("mitaMenuType", JSON.stringify(this.menuType));
      this.$emit("menu-type-changed", this.menuType);
      window.location.reload();
    },
    increaseFont() {
      this.currentIndex = Math.min(this.currentIndex + 1, 10);
      if (this.currentIndex < 10) {
        for (const key in this.fontSizes) {
          this.fontSizes[key] += 0.5;
          document.documentElement.style.setProperty(
            `--font-size-${key.toLowerCase()}`,
            `${this.fontSizes[key]}pt`,
          );
        }
      }
    },
    decreaseFont() {
      this.currentIndex = Math.max(this.currentIndex - 1, 1);
      if (this.currentIndex > 1) {
        for (const key in this.fontSizes) {
          this.fontSizes[key] -= 0.5;
          document.documentElement.style.setProperty(
            `--font-size-${key.toLowerCase()}`,
            `${this.fontSizes[key]}pt`,
          );
        }
      }
    },
    setFontFamily() {
      const key = this.fontFamily;
      const fontName = this.fontFamilies[key];
      document.documentElement.style.setProperty(
        "--font-family-main",
        fontName,
      );
      const appEl = document.querySelector(".v-application");
      if (appEl) {
        appEl.style.fontFamily = fontName;
      }
    },
    setDateType() {
      let form = {
        dateType: this.dateType,
        dateTimeFormat: this.dateTimeFormat,
      };
      this.$store.dispatch("editDateType", form);
    },
  },
  mounted() {
    this.$store.dispatch("getCurrentUser");
    this.$store.dispatch("dropdownX/getDateTypes");
    this.$store.dispatch("dropdownX/getDateTimeFormats");
    if (JSON.parse(localStorage.getItem("mitaLanguage"))) {
      this.language = JSON.parse(localStorage.getItem("mitaLanguage"));
    }
    if (JSON.parse(localStorage.getItem("mitaThemeColor"))) {
      const theme = JSON.parse(localStorage.getItem("mitaThemeColor"));
      document.body.classList.add(theme + "-theme");
    }
    if (
      JSON.parse(localStorage.getItem("mitaMenuType")) == true ||
      JSON.parse(localStorage.getItem("mitaMenuType")) == false
    ) {
      this.menuType = Boolean(JSON.parse(localStorage.getItem("mitaMenuType")));
      setTimeout(() => {
        this.$emit("menu-type-changed", this.menuType);
      }, 100);
    }
  },
};
</script>
